import { REPORTS_ACTIONS } from "./actionTypes";
export const ReportsStateSelectors = {
  view: state => state.reports[REPORTS_ACTIONS.VIEW],
  generate: state => state.reports[REPORTS_ACTIONS.GENERATE]
};